import request from '@/utils/ajax';

export function queryRoleList(data){
  return request({
    url: `/wx/sys/role/select`,
    method: 'get',
  });
}

export function queryPermissionList(data){
  return request({
    url: `/wx/sys/dataPermissionTree/list`,
    method: 'get',
    params: data
  });
}

export function queryPermissionKeys(data){
  return request({
    url: `/wx/sys/dataPermissionUser/userTree`,
    method: 'get',
    params: data
  });
}

export function addRole(data){
  return request({
    url: `/wx/sys/role/save`,
    method: 'post',
    data
  });
}

export function queryRoleDetail(data){
  return request({
    url: `/wx/sys/role/info/${data.roleId}`,
    method: 'get',
  });
}

export function updateRole(data){
  return request({
    url: `/wx/sys/role/update`,
    method: 'post',
    data
  });
}

export function deleteRole(data){
  return request({
    url: `/wx/sys/role/delete`,
    method: 'post',
    data
  });
}
